import { createAction } from '@ngrx/store';

export const agreeTermsConditions = createAction(
  '[Additional Services] Agree Terms & Conditions'
);
export const resetTermsConditions = createAction(
  '[Additional Services] Reset Terms & Conditions'
);

export type TermsConditionsActions =
  | typeof agreeTermsConditions
  | typeof resetTermsConditions;
